import _ from 'lodash';
// ---- external imports -----

import CustomerBuilder from '~/models/customer';
import {
	CUSTOMER_APPEARANCE_GROUP,
	CUSTOMER_ANIMATION_STATE,
} from '~/containers/game-user/customers-wrapper/animationConstants';
import { CUSTOMER_TYPES } from '~/lib/constants';
// ---- internal imports -----

import { productsSelectors } from '../';
// ---- parent imports -----

const CUSTOMERS_TYPES_SALES_PREFERENCE = {
	[CUSTOMER_TYPES.FIXED_PRICE]: 2,
	[CUSTOMER_TYPES.WHATEVER_PRICE]: 4,
	[CUSTOMER_TYPES.CREDIT]: 0,
	[CUSTOMER_TYPES.BARGAINING]: 1,
	[CUSTOMER_TYPES.LAZY]: 3
}

function orderCustomersBySellingPreference(customers) {
	return customers.sort(
		(c1, c2) => 
			CUSTOMERS_TYPES_SALES_PREFERENCE[c2.type] - CUSTOMERS_TYPES_SALES_PREFERENCE[c1.type]
	);
}

function getSalesFromValidCustomers(state, validViewingCustomers) {
	let productsCount = {
		couch: productsSelectors.getCouch(state).amount,
		chair: productsSelectors.getChair(state).amount,
		table: productsSelectors.getTable(state).amount,
	};

	const orderedCustomers = orderCustomersBySellingPreference([...validViewingCustomers]);

	const salesCustomers = orderedCustomers.map(
		(cust) => {
			if(productsCount[cust.productName] > 0) {
				productsCount[cust.productName] = productsCount[cust.productName] - 1;
			}
			else {
				cust = null;
			}
			return cust;
		}
	);
	return salesCustomers.filter((cust) => cust !== null);
}

/**
* returns a randomly shuffled indicies for each customer appearnce group
* @param {Object} customerCountByAppearanceGroup The Number of customers by each appearnce group
* @return {Object}	{0: [2,4,1], 1: [0], 2: [3]} Appearnce indicies order for each appearnce group
*/
function getShuffledIndicesByAppearanceGroup(customerCountByAppearanceGroup) {
	let accumelatedGroupCounter = 0;
	const shuffledIndicesByAppearanceGroup = {};
	Object.entries(customerCountByAppearanceGroup)
		.forEach(([appearanceGroup, customerCountInGroup]) => {
			const accCountWithCurrentGroup = accumelatedGroupCounter + customerCountInGroup;
			const shuffledIndices = 
				_.shuffle(_.range(accumelatedGroupCounter, accCountWithCurrentGroup));
			shuffledIndicesByAppearanceGroup[appearanceGroup] = shuffledIndices;
			accumelatedGroupCounter = accCountWithCurrentGroup;
		});

	return shuffledIndicesByAppearanceGroup;
}

/**
* ADDS the appearnce order of customers per screen 
* @param {Array} visibleCustomers customers without appearance order
* @return {Object}	Customemrs with Appearance order added
*/
function addAnimationOrder(visibleCustomers, hasProductsInStock = true) {
	const customers = visibleCustomers.filter((c) => c !== null);
	const customerCountByAppearanceGroup =
		_.countBy(customers, (c) => (CUSTOMER_APPEARANCE_GROUP[c.type]));
	const shuffledIndicesByAppearanceGroup = 
		getShuffledIndicesByAppearanceGroup(customerCountByAppearanceGroup);

	return visibleCustomers.map((customer) => {
		if (
			customer === null ||
			customer.animationState === CUSTOMER_ANIMATION_STATE.IDLE
		) {
			return customer;
		}
		const customerAppearanceGroup = CUSTOMER_APPEARANCE_GROUP[customer.type];

		const animationOrderIndex = 
			shuffledIndicesByAppearanceGroup[customerAppearanceGroup].pop();
		const animationState = hasProductsInStock
			? CUSTOMER_ANIMATION_STATE.WAITING_TO_APPEAR
			: CUSTOMER_ANIMATION_STATE.IDLE_NO_SELL;

		return {
			...customer,
			animationOrderIndex,
			animationState,
		};
	});
}

function createCustomersModels(customers) {
	return customers.map((customer) => {
		return new CustomerBuilder()
			.withId(customer.id)
			.withType(customer.type)
			.withOfferPrice(customer.offer_price)
			.withNegotiatedPrice(customer.negotiated_price)
			.withProductName(customer.product_name)
			.withProductType(customer.product_type)
            .withState(customer.state)
			.build().toPlainObj();
	});
}

export {
    getSalesFromValidCustomers,
    addAnimationOrder,
    createCustomersModels
}